import { useEffect, useRef, useState } from "react";
import styles from "../../shared/styles.module.scss";
import { updateDataLayer } from "@utils/updateDataLayer";

import Overweight from "./assets/img/overweight.png";
import Underweight from "./assets/img/underweight.png";
import Normal from "./assets/img/normal.png";
import Obese from "./assets/img/obese.png";
import After from "./assets/img/after.png";
import {
  FAQSection,
  Guarantee,
  Partners,
  PaywallChart,
  PersonalPlan,
  Plan,
  ResultsSlider,
  Reviews,
  Timer,
  Transform,
} from "../../shared/components";

import { ProfileCard } from "./components/profileCard";
import { Benefits } from "./components/benefits";
import { useDispatch } from "react-redux";
import { UpsaleModal } from "../../shared/components/upsaleModal";
import { CalorieCounter } from "../../shared/components/calorieCounter";
import { AdditionalDiscount } from "../../shared/components/additionalDiscount";
import useLocationEvent from "@hooks/useLocationEvent";
import { ReliefSlider } from "./components/lastingRelief";
import { getPaywallCountdown } from "src/appConfig";
import { DiscountProvider } from "@hooks/useDiscount";
import { getPlansThunk } from "src/redux/slices/plansSlice";

const BMI_TYPE_IMAGES = {
  NORMAL: Normal,
  OVERWEIGHT: Overweight,
  OBESE: Obese,
  UNDERWEIGHT: Underweight,
  After,
};

export const Paywall = () => {
  const storedCountdown = getPaywallCountdown();

  const parsedCountdown = storedCountdown
    ? parseInt(storedCountdown, 10)
    : null;

  const skipTimer = parseInt(parsedCountdown) === -1;

  const dispatch = useDispatch();
  const [upsaleModalVisible, setUpsaleModalVisible] = useState(false);
  const [showTimer, setShowTimer] = useState(false);

  const faqSectionRef = useRef(null);

  const planRef = useRef(null);
  const profileCardRef = useRef(null);

  useLocationEvent();

  useEffect(() => {
    if (skipTimer) return;

    const handleScroll = () => {
      if (profileCardRef.current && !showTimer) {
        const rect = profileCardRef.current.getBoundingClientRect();
        const isVisible = rect.top <= window.innerHeight && rect.bottom >= 0;

        if (isVisible) {
          setShowTimer(true);
          window.removeEventListener("scroll", handleScroll);
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleScrollToPlan = () => {
    planRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const handleCheckoutClose = () => {
    setUpsaleModalVisible(true);
  };

  useEffect(() => {
    document.body.style.overflow = upsaleModalVisible ? "hidden" : "auto";
  }, [upsaleModalVisible]);

  const hasAdditionalDiscount =
    localStorage.getItem("additionalDiscount") === "true";

  useEffect(() => {
    dispatch(getPlansThunk());
  }, []);

  return (
    <DiscountProvider>
      <div className={styles.layout}>
        {showTimer && (
          <Timer
            onGetMyPlanClick={handleScrollToPlan}
            onTimeEnd={() => setShowTimer(false)}
            customTime={parsedCountdown * 1000}
          />
        )}
        {hasAdditionalDiscount && <AdditionalDiscount />}
        {!hasAdditionalDiscount && (
          <>
            <Transform title="Fitness" images={BMI_TYPE_IMAGES} />
            <PersonalPlan />
          </>
        )}
        <CalorieCounter />
        <div ref={planRef}>
          <Plan
            id={1}
            title="AI-optimized plan"
            isMetrics
            onCloseCheckout={handleCheckoutClose}
            additionalDiscount={hasAdditionalDiscount}
            showTimer={skipTimer || showTimer} // Отображаем стоимость продуктов со скидкой (то есть так же, как и при первом открытии экрана пейвола в процессе прохождения воронки) если skipTimer
          />
        </div>
        <div ref={profileCardRef}>
          <ProfileCard />
        </div>
        <PaywallChart />

        <Plan
          id={2}
          title="Get visible results in 4 weeks!"
          onCloseCheckout={handleCheckoutClose}
          additionalDiscount={hasAdditionalDiscount}
          showTimer={showTimer}
        />

        <Benefits />
        <Partners />
        <ReliefSlider />
        <ResultsSlider />
        <div ref={faqSectionRef}>
          <FAQSection />
        </div>
        <Reviews />
        <Plan
          id={3}
          title="Get visible results in 4 weeks!"
          onCloseCheckout={handleCheckoutClose}
          additionalDiscount={hasAdditionalDiscount}
          showTimer={showTimer}
        />

        <Guarantee />
        <footer className={styles.footer}>
          Straiton Limited | Alpha Tower, Floor 1, Office 11, <br /> Pavlou
          Nirvana- Aipeias, Limassol, 3021, Cyprus
        </footer>
      </div>
      {upsaleModalVisible && (
        <UpsaleModal
          onClose={() => setUpsaleModalVisible(false)}
          text="Personal Loss Weight plan."
        />
      )}
    </DiscountProvider>
  );
};
